export default __webpack_public_path__ + "static/media/img-features-banner.4d86369f.svg";